module.exports = __webpack_public_path__ + "static/media/teltonika.3002092a.png";